<template>
  <div>
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Products</h3>
        <table class="product-table DisplayTable">
          <thead>
              <tr>
                <th v-if="editingId != null">Product code</th>
                <th v-else
                  @click ="sort('code')"
                  :class="currentSortDir == 'asc' ? 'ReportsAscIcon' :'ReportsDescIcon'">
                  Product code
                </th>
                <th>Product Description</th>
                <th>Price</th>
                <th>Cost</th>
                <th class="buttonCol" />
              </tr>
            </thead>
            <tbody>
              <tr height="30px">
                <td class="product-table-cell"><input type="text" v-model="code" placeholder="Product Code" @change="checkDuplicate(code, 'new')" ></td>
                <td class="product-table-cell"><input type="text" v-model="description" placeholder="Product Description" class="ProductDescription" 
                  @change="allDataEntered(code, description, price, cost)"></td>
                <td class="product-table-cell">
                  <input type="number"
                  step = ".1"
                  min = 0
                  v-model = "price"
                  placeholder = "Price" class ="price"
                  @change="allDataEntered(code, description, price, cost)">
                </td>
                <td class="product-table-cell">
                  <input type="number"
                  step = ".1"
                  min = 0
                  v-model = "cost"
                  placeholder = "Cost" class ="price"
                  @change="allDataEntered(code, description, price, cost)">
                </td>
                <td v-if="editingId != null" class="product-table-cell center">
                  <button class="addrecordbutton icon btnDisabled" hidden></button>
                </td>
                <td v-else-if="ProdValid && AllData && editingId === null" class="product-table-cell center">
                  <button v-on:click="createProduct(code, description, price, cost)" class="addrecordbutton icon" title="Add product"></button>
                </td>
                <td v-else class="product-table-cell center">
                  <button class="addrecordbutton icon btnDisabled" title="Not all data has been entered to add record" disabled></button>
                </td>
              </tr>
              <tr v-for= "(product, indexProduct) in sortedProducts" :key="indexProduct" height="30px" data-is-editable="0">
                <td class="product-table-cell" >
                  <input type="text" 
                    v-model="product.code" 
                    :readonly="editingId == indexProduct ? false : true" 
                    :class="editingId == indexProduct ? 'editable' :''"  
                    @change="checkDuplicate(product.code.toUpperCase(), 'update')">
                </td>
                <td class="product-table-cell">
                  <input type="text" 
                    v-model="product.description" 
                    :readonly="editingId == indexProduct ? false : true" 
                    :class="editingId == indexProduct ? 'ProductDescription editable' :'ProductDescription'" 
                    @change="allDataEntered(product.code.toUpperCase(), product.description, product.price, product.cost)">
                </td>
                <td class="product-table-cell">
                <input type="number"
                  step=".1"
                  min = 0
                  v-model="product.price"
                  :readonly="editingId == indexProduct && !product.productUsed ? false : true"
                  :class="editingId == indexProduct && !product.productUsed ? 'editable price' :'price'"
                  @change="allDataEntered(product.code.toUpperCase(), product.description, product.price, product.cost)">
                </td>
                <td class="product-table-cell">
                <input type="number"
                  step=".1"
                  min = 0
                  v-model="product.cost"
                  :readonly="editingId == indexProduct && !product.productUsed ? false : true"
                  :class="editingId == indexProduct && !product.productUsed ? 'editable price' :'price'"
                  @change="allDataEntered(product.code.toUpperCase(), product.description, product.price, product.cost)">
                </td>
                <td class="product-table-cell">
                    <span v-if="editingId === null">
                      <button v-on:click="editItem(indexProduct)" class="editbutton icon" title="Edit Product"></button>
                      <button v-on:click="deleteProduct(product.id, product.code.toUpperCase())" class="deletebutton icon" title="Delete Product"></button>
                    </span>
                    <span v-else-if="editingId === indexProduct">
                      <span v-if="!ProdValid || !AllData">
                        <button class="savebutton icon btnDisabled" title="Not all data has been entered to save record" disabled></button>
                      </span>
                      <span v-else>
                        <button v-on:click="updateProduct(product.id, product.code.toUpperCase(), product.description, product.price, product.cost)" 
                          class="savebutton icon" title="Save">
                        </button>
                      </span>
                      <button v-on:click="canceledit(indexProduct)" class="cancelbutton icon" title="Cancel"></button>
                    </span>
                    <span v-else>
                      <button class="editbutton icon btnDisabled" hidden></button>
                      <button class="deletebutton icon btnDisabled" hidden></button>
                    </span>
                  </td>
              </tr>
            </tbody>
        </table>
      </div>

        <div v-if="message" class="errormessage">
          <table>
            <tr>
              <td>{{message}}</td>
            </tr>
          </table>
        </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { listProducts } from '../graphql/queries';
import { listContracts } from '../graphql/queries';
import { createProduct } from '../graphql/mutations';
import { updateProduct } from '../graphql/mutations';
import { deleteProduct } from '../graphql/mutations';
import { onCreateProduct } from '../graphql/subscriptions';
import { getProductByCode } from '../graphql/queries';
import UserInfoStore from '../app/user-info-store';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";

export default {
  name: 'app',
  props: ['prods'],
  components:{
    RwvMenu,
  },
  async created() {
  // console.log('created ...')
    this.getProducts();
    this.subscribeCreate();
    },
    data() {
      return {
        products: [],
        frozenProducts: [],
        productedit: [],
        contracts: [],
        editingId: null,
        code: '',
        description: '',
        price:'',
        cost: '',
        id:'',
        Duplicate: [],
        dupCode: '',
        message: '',
        ProdValid: false,
        AllData: false,
        Origdata: [],
        currentSort: 'code',
        currentSortDir: 'asc',
        UserGroup: UserInfoStore.state.userGroup,
        UserBranch: UserInfoStore.state.branchName,
      }
  },
  computed: {
    sortedProducts: function() {
      // console.log('sortedProducts ...');
      if (this.editingId != null) {return this.frozenProducts}
      return this.products.slice().sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] === null | a[this.currentSort] === undefined) return 1 * modifier;
        if(b[this.currentSort] === null | b[this.currentSort] === undefined) return -1 * modifier;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
        });
      }
  },
  watch: {
    sortedProducts: {
      handler: function() {
        if (this.editingId === null) {
          this.frozenProducts = this.sortedProducts.slice()
        }
      }     
    }
  },
  methods: {
    reset(){
      Object.assign(this.$data, this.$options.data.apply(this));
      this.getProducts();     
    },
    async getProducts() {
      // console.log('getProducts ...')
      try {
        const products = await API.graphql({
          query: listProducts
        });
        this.products = products.data.listProducts.items;
        var i;
        for (i=0; i<this.products.length; i++) {
          this.products[i].price = this.products[i].price.toFixed(2);
          this.products[i].cost = this.products[i].cost.toFixed(2);
        }
        this.getContracts();
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('getProducts end ...')
    },
    async getContracts() {
 //      console.log("getContracts ...")
      try {
        const Contracts = await API.graphql({
        query: listContracts
      });
      this.contracts = Contracts.data.listContracts.items;
      for (var i=0; i < this.products.length; i++) {
        this.products[i].productUsed = false;
        for (var j=0; j < this.contracts.length; j++) {
          if (this.products[i].id === this.contracts[j].productId){
            this.products[i].productUsed = true;
          }
        }
      }
      }
      catch (error) {
        //console.log(error)
        this.message = commonFunctions.displayError(error);
      }
  //     console.log('getContracts end ...')
    },
                                                                // check duplicates
    async checkDuplicate(code, Updatetype) {
      // console.log('checkDuplicate ...')
      this.message = '';
      if (!commonFunctions.xssTest(code)) {
        this.message = commonFunctions.xssMessage("Product Code")
        this.ProdValid = false;
        return
      }
      try{
        if(code != ''){
          this.ProdValid = true
          code = code.toUpperCase()
          if (Updatetype === "new"){this.code = this.code.toUpperCase()}
          if (Updatetype != "new" && this.products[this.editingId].code === this.dupCode){
            return
          }
          const QueryVariables = {code};
          const Product = await API.graphql({
            query: getProductByCode,
            variables: QueryVariables,
          });
          this.DupProduct = Product.data.getProductByCode.items;
          if (this.DupProduct[0]){                                //Confirm duplicate
            this.message = "This product code already exists";
            this.ProdValid = false;
            return;
          }}
        else {this.ProdValid = false}
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('checkDuplicate end');
    },
                                                                // Check all data has been entered
    allDataEntered(code, description, price, cost){
      // console.log ("allDataEntered ...");
      this.message = ""
      if (!price || !description || !code || price < 0.01 || cost < 0.01 ){
        this.AllData = false;}
      else {
        this.AllData = true;}
      if (price < 0.01 && price != "") {
        this.message = "Price must be greater than zero";
        this.AllData = false;
      }
      if (cost < 0.01 && cost != "") {
        this.message = "Cost must be greater than zero";
        this.AllData = false;
      }
      if (cost > price && cost != "" && price != "") {
        this.message = "Cost must be less than Price";
        this.AllData = false;
      }
      // console.log ("allDataEntered end");
    },
                                                                // Create Products
    async createProduct(cde, descrip, prce, cst) {
      // console.log('createProduct ...')
      if (!cde || !prce || !descrip || !this.ProdValid || !cst){
        confirm("please enter data in all the fields");
        return;
      }
      this.message='';
      if (!commonFunctions.xssTest(cde)) {
        this.message = commonFunctions.xssMessage("Product Code")
        return
      }
      if (!commonFunctions.xssTest(descrip)) {
        this.message = commonFunctions.xssMessage("Product Description")
        return
      }
      try {
        let code = cde.trim();
        let description = descrip.trim();
        var price = prce * 1;
        var cost = cst * 1;
        price = price.toFixed(2);
        cost = cost.toFixed(2)
        const CreateValues = { code, price, cost, description }
        await API.graphql({
          query: createProduct,
          variables: {input: CreateValues},
        });
        this.resetVariables()
      }
      catch (error) {
        console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('createProducts end ...');
    },
                                                                // Update view on create
    subscribeCreate () {
      API.graphql({
        query: onCreateProduct
      })
      .subscribe ({
        next: (items) => {
          const product = items.value.data.onCreateProduct;
          if (this.products.some(item => item.name === product.code)) return; // remove duplications
          this.products = [...this.products, product];
        }
      })
    },
                                                                // Update Products
    async updateProduct(id, cde, descrip, prce, cst) {
 //      console.log('updateProduct ...')
      if (!cde || !prce || !descrip || !cst){
          confirm("please enter data in all the fields");
          return;
      }
      this.message = "";
      if (!commonFunctions.xssTest(cde)) {
        this.message = commonFunctions.xssMessage("Product Code")
        return;
      }
      if (!commonFunctions.xssTest(descrip)) {
        this.message = commonFunctions.xssMessage("Product Description")
        return;
      }
      try {
        let code = cde.trim();
        let description = descrip.trim();
        var price = prce * 1;
        var cost = cst * 1;
        price = price.toFixed(2);
        cost = cost.toFixed(2)
        const UpdateValues = { id, code, price, cost, description };
        // console.log('product =', UpdateValues)
        await API.graphql({
          query: updateProduct,
          variables: {input: UpdateValues},
        });
        this.editingId = null;
        this.getProducts()
    //    this.$forceUpdate();
    }
    catch (error) {
      console.log(error)
      this.message = commonFunctions.displayError(error);
    }
      // console.log('updateProduct end ...');
    },

                                                                // Delete Products
    async deleteProduct(id, prodName) {
      // console.log('deleteProduct ...');
      if(confirm("Do you really want to delete product (" + prodName + ") ?")) {
                                                                // check if any contracts for this product
        try {
          this.message="";
          var filter;
          var limit = 2000;
          filter ={
            productId: {eq: id}
            }
          const Contracts = await API.graphql({
            query: listContracts,
            variables: {filter: filter, limit: limit}
            });
          this.Contracts = Contracts.data.listContracts.items;
          if (this.Contracts[0]){
            this.message = "Contracts exist for this product. It cant be deleted";
            return;
          }
          const product = {id};
          // console.log('product =', product)
          await API.graphql({
            query: deleteProduct,
            variables: {input: product},
          });
          this.getProducts();
        }
        catch (error) {
          console.log(error)
          this.message = commonFunctions.displayError(error);
        }
      }
      // console.log('deleteProduct end ...');
    },
                                                                // set row in edit mode
    editItem(indexRow) {
      // console.log('editItem ...');
      // console.log('indexProduct = ', indexRow);
      this.editingId = indexRow;
      this.resetVariables();
      this.dupCode = this.products[this.editingId].code;
      this.ProdValid = true;
      this.AllData = true;
    },
                                                                // Reset row to original values
    canceledit() {
      // console.log('Cancel Edit ...')
      this.editingId = null
      this.ProdValid = false;
      this.AllData = false;
      this.reset();
      // console.log('Cancel Edit end')
    },
    resetVariables() {
      this.code = '';
      this.description = '';
      this.price = '';
      this.cost = '';
      this.AllData = false;
      this.ProdValid = false;
    },
    sort: function(s) {
      // console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },

}
}
</script>
<style>
</style>
